<app-page-header>
  <div>Organisationsübersicht</div>

<!--  <div class="rounded-lg flex flex-row justify-end items-center gap-2 h-10">-->
<!--    <bic-button (onClick)="openNewOrganisation()" buttonType="white" class="mr-2 h-10 inline-flex"-->
<!--    >Organisation-->
<!--      <fa-icon [icon]="faPlus" iconLeft></fa-icon>-->
<!--    </bic-button>-->
<!--    <div class="rounded-lg flex flex-row h-full justify-end items-center ml-auto border border-gray-300">-->
<!--      &lt;!&ndash; Grid View Button &ndash;&gt;-->
<!--      <button tooltip="Kachelansicht" (click)="setCardView()" class="flex flex-row p-2 rounded-l">-->
<!--        <div class="flex h-5 w-5 justify-center items-center">-->
<!--          <fa-icon [icon]="faGrid2" [ngClass]="isCardView ? 'text-gray' : 'text-gray-300'"></fa-icon>-->
<!--        </div>-->
<!--      </button>-->

<!--      <div class="border-l-2 border-gray-300 h-6"></div>-->

<!--      &lt;!&ndash; List View Button &ndash;&gt;-->
<!--      <button tooltip="Listenansicht" (click)="setListView()" class="flex flex-row p-2 rounded-l">-->
<!--        <div class="flex h-5 w-5 justify-center items-center">-->
<!--          <fa-icon [icon]="faBars" [ngClass]="isListView ? 'text-gray' : 'text-gray-300'"></fa-icon>-->
<!--        </div>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--&lt;!&ndash;  00000000000000000000000000000000000000000000000000000000000000000000000000000000000&ndash;&gt;-->
  <div class="flex flex-row items-center gap-4">

    <bic-input
      class="w-[400px]"
      placeholder="Suchen nach..."
      [maxLength]="64"
      [iconStart]="faMagnifyingGlass"
      [showX]="true"
      (valueChange)="applyFilter($event)">
    </bic-input>
    <bic-button (onClick)="openNewOrganisation()" buttonType="white">Organisation
      <fa-icon [icon]="faPlus" iconLeft></fa-icon>
    </bic-button>
  </div>
</app-page-header>

@if (loading) {
  <div class="flex flex-col justify-start items-start w-full h-full gap-2 overflow-y-auto">
    <div class="flex flex-col justify-start items-start p-2 w-full pb-20">
      <div class="grid grid-flow-row gap-6 w-full h-full p-2"
           style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
        @for (skeleton of [1, 2, 3, 4]; track skeleton) {
          <div class="flex flex-col gap-4 p-4 border border-gray-200 rounded-lg animate-pulse">
            <div class="flex flex-row items-center justify-between">
              <div class="h-5 bg-gray-200 rounded-full w-40"></div>
              <div class="h-5 bg-gray-200 rounded-full w-5"></div>
            </div>
            <div class="flex flex-col gap-4">
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full flex-1"></div>
                <div class="h-5 bg-gray-200 rounded-full w-12"></div>
              </div>
              <div class="flex flex-row gap-4 items-center">
                <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div class="h-5 bg-gray-200 rounded-full flex-1"></div>
                <div class="h-5 bg-gray-200 rounded-full w-12"></div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="flex flex-row w-full justify-center items-center gap-2 pt-8">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
        <span class="text-sm font-medium text-gray-500">Organisationen werden geladen...</span>
      </div>
    </div>
  </div>
}

@if (!loading) {
  <div class="flex flex-col justify-start items-start h-full w-full gap-2">
    <div class="flex flex-row justify-start items-start flex-wrap w-full overflow-y-scroll p-2">
        <div class="flex flex-col justify-start items-start p-2 w-full pb-20">
          <div class="grid grid-flow-row gap-6 w-full h-full p-2"
               style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
            @if (showPersonalProfile()) {
            <bic-card (click)="navigateToPersonalProjects()">
              <div class="flex flex-col gap-4 h-full w-full overflow-hidden">
                <!-- Project Name and Menu Icon -->
                <div class="flex flex-row items-center justify-between">
                  <div
                    class="flex w-full text-base text-gray-900 font-medium overflow-hidden break-words hyphens-auto line-clamp-1">
                    Persönlich
                  </div>
                  <div (click)="$event.stopPropagation()" [bicDropdownTrigger]="dropdownPersonal"
                       class="hover:opacity-50 px-2 text-base text-gray-900 font-medium">
                    <fa-icon [icon]="faEllipsisVertical"></fa-icon>
                  </div>
                  <bic-dropdown #dropdownPersonal [dropdownPlacement]="'bottom-end'">
                    <bic-dropdown-element (click)="$event.stopPropagation(); router.navigate(['/profile'])">
                      <div class="flex flex-row text-sm gap-3 text-gray-700">
                        <span>Profil bearbeiten</span>
                      </div>
                    </bic-dropdown-element>
                  </bic-dropdown>
                </div>
                <div class="flex flex-col justify-end w-full h-full items-center gap-4">
                  <div class="flex flex-row gap-4 w-full items-center">
                    <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                      <fa-icon [icon]="faUserGroup" class="text-base text-gray-900 font-medium"></fa-icon>
                    </div>
                    <div class="w-full text-base text-gray-900 font-medium ">Personen</div>
                    <div class="text-base text-gray-500 px-2">1</div>
                  </div>
                  <div class="flex flex-row gap-4 w-full items-center">
                    <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                      <fa-icon [icon]="faBuilding" class="text-base text-gray-900 font-medium"></fa-icon>
                    </div>
                    <div class="w-full text-base text-gray-900 font-medium">Projekte</div>
                    <div class="px-2 text-base text-gray-500">{{ numberOfPersonalProjects }}</div>
                  </div>
                  <div class="flex flex-row gap-4 justify-start w-full items-center">
                    <ng-container>
                      @if (user.profileImage) {
                        <img alt="Verantwortlich" class="w-6 h-6 rounded-full"
                             (error)="user.profileImage = undefined"
                             src="{{user.profileImage}}">
                      }
                      @if (!user.profileImage) {
                        <div
                          class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full">
                          <span
                            class="text-base text-gray-900 font-medium ">{{ user.firstName?.charAt(0)?.toUpperCase() + '' + user.lastName?.charAt(0)?.toUpperCase() }}</span>
                        </div>
                      }
                      <div class="flex flex-col">
                        <span class="text-base text-gray-900 font-medium">
                          {{ user.firstName + ' ' + user.lastName }}
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </bic-card>
            }
            @for (organisation of dataSource.filteredData; track organisation) {
              <bic-card (click)="navigateToOrganisation(organisation)">
                <div class="flex flex-col gap-4 h-full w-full overflow-hidden">
                  <!-- Project Name and Menu Icon -->
                  <div class="flex flex-row items-center justify-between">
                    <div
                      class="w-full text-base text-gray-900 font-medium overflow-hidden break-words hyphens-auto line-clamp-1">
                      {{ organisation.name }}
                    </div>
                    <div (click)="$event.stopPropagation()" [bicDropdownTrigger]="dropdownOrga"
                         class="hover:opacity-50 px-2 text-base text-gray-900 font-medium">
                      <fa-icon [icon]="faEllipsisVertical" class="w-4"></fa-icon>
                    </div>
                    <bic-dropdown #dropdownOrga [dropdownPlacement]="'bottom-end'">
                      <bic-dropdown-element (click)="$event.stopPropagation()"
                                            (onClick)="navigateToOrganisationSettings(organisation)">
                        <div class="flex flex-row text-sm gap-3 text-gray-900 font-normal">
                          <span>Einstellungen</span>
                        </div>
                      </bic-dropdown-element>
                      @if (!(organisation.users?.length === 1 && organisation.users?.[0]?.id === user?.id)) {
                        <bic-dropdown-element
                          (click)="$event.stopPropagation()" (onClick)="openLeaveOrganisation(organisation)">
                          <div class="flex flex-row text-sm gap-3 text-red-500">
                            <span>Verlassen</span>
                          </div>
                        </bic-dropdown-element>
                      }
                      @if (getIsAdmin(organisation)) {
                        <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="openDeleteOrganisation(organisation)">
                          <div class="flex flex-row text-sm gap-3 text-red-500">
                            <span>Löschen</span>
                          </div>
                        </bic-dropdown-element>
                      }

                      <!--                      @if (!getIsAdmin(organisationList) || otherAdmins.get(organisationList.id)) {-->
<!--                        <bic-dropdown-element-->
                      <!--                          (click)="$event.stopPropagation()" (onClick)="openLeaveOrganisation(organisationList)">-->
<!--                          <div class="flex flex-row text-sm gap-3 text-red-500">-->
<!--                            <span>Verlassen</span>-->
<!--                          </div>-->
<!--                        </bic-dropdown-element>-->
<!--                      }-->
                      <!--                      @if (getIsAdmin(organisationList) && !(organisationList.users?.length === 1 && organisationList.users[0]?.id === user?.id)) {-->
                      <!--                        @if (!otherAdmins.get(organisationList.id)) {-->
<!--                          <bic-dropdown-element-->
                      <!--                            (click)="$event.stopPropagation()" (onClick)="openDeleteAndLeaveOrganisation(organisationList)">-->
<!--                            <div class="flex flex-row text-sm gap-3 text-red-500">-->
<!--                              <span>Löschen und Verlassen</span>-->
<!--                            </div>-->
<!--                          </bic-dropdown-element>-->
<!--                        }-->
<!--                      }-->
                      <!--                    @if (organisationList.users?.length === 1 && organisationList.users[0]?.id === user?.id) {-->
                      <!--                      <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="openDeleteOrganisation(organisationList)">-->
<!--                        <div class="flex flex-row text-sm gap-3 text-red-500">-->
<!--                          <span>Löschen</span>-->
<!--                        </div>-->
<!--                      </bic-dropdown-element>-->
<!--                    }-->
                    </bic-dropdown>
                  </div>
                </div>
                <!--Project Information-->
                <div class="flex flex-col justify-end w-full h-full items-center pt-4 gap-4">
                  <div class="flex flex-row gap-4 w-full items-center">
                    <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                      <fa-icon [icon]="faUserGroup" class="text-base text-gray-900 font-medium"></fa-icon>
                    </div>
                    <div class="w-full text-base text-gray-900 font-medium">Personen</div>
                    <div class="text-base text-gray-500 font-medium px-2">{{ organisation.users?.length ?? 0 }}</div>
                  </div>
                  <div class="flex flex-row gap-4 w-full items-center">
                    <div class="flex flex-row w-6 shrink-0 justify-center items-center">
                      <fa-icon [icon]="faBuilding" class="text-base text-gray-900 font-medium"></fa-icon>
                    </div>
                    <div class="w-full text-base text-gray-900 font-medium">Projekte</div>
                    <div class="text-base font-medium text-gray-500 px-2">{{ organisation.numberOfProjects }}</div>
                  </div>
                  <div class="flex flex-row gap-4 justify-start w-full items-center">
                    <ng-container>
                      @if (user.profileImage) {
                        <img alt="Verantwortlich" class="w-6 h-6 rounded-full"
                             (error)="user.profileImage = undefined"
                             src="{{user.profileImage}}">
                      }
                      @if (!user.profileImage) {
                        <div
                          class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full">
                          <span
                            class="text-base text-gray-900 font-medium">{{ user.firstName?.charAt(0)?.toUpperCase() + '' + user.lastName?.charAt(0)?.toUpperCase() }}</span>
                        </div>
                      }
                      <div class="flex flex-col">
                        <span class="text-base text-gray-900 font-medium">
                          {{ user.firstName + ' ' + user.lastName }}
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </bic-card>
            }
            <!-- we do not want to show the organisationList add panel for now -->
            <!--        <div class="p-2">-->
            <!--          <div class="flex flex-col justify-center items-center w-[364px] h-[216px] rounded-lg p-2 border border-gray-200 transform transition ease-in-out hover:scale-[102%] cursor-pointer" (click)="openNewOrganisation()">-->
            <!--            <fa-icon class="text-gray-300 text-[32px]" [icon]="faPlus"></fa-icon>-->
            <!--            <span class="text-gray-300 font-medium text-lg">Organisation hinzufügen</span>-->
            <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>


      @if (leaveOrganisationBoolean) {
        <bic-popup (close)="leaveOrganisationBoolean = false" [hasBackdrop]="true" [title]="'Möchten Sie die Organisation '+ '“' +selectedOrganisation!.name + '”' +' verlassen?'" customClass="w-[560px] h-fit">
          <div bicPopupContent class="flex flex-col">
            <span class="font-normal">Bei Bestätigung verlieren Sie mit sofortiger Wirkung den Zugriff auf sämtliche Projekte der Organisation, sowie die Organisationsverwaltung und Mitglieder.</span>
          </div>
          <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
            <bic-button (onClick)="leaveOrganisationBoolean = false" buttonType="white">Abbrechen</bic-button>
            <bic-button (onClick)="leaveOrganisation(selectedOrganisation!)" buttonType="red">Verlassen</bic-button>
          </div>
        </bic-popup>
      }
      @if (deleteOrganisationBoolean) {
        <bic-popup (close)="deleteOrganisationBoolean = false" [hasBackdrop]="true" [title]="'Möchten Sie die Organisation '+ '“' +selectedOrganisation!.name + '”' +' löschen?'" customClass="w-[560px] h-fit">
          <div bicPopupContent class="flex flex-col">
            <span class="font-normal">Bei Bestätigung wird die Organisation “{{ selectedOrganisation!.name }}” unwiderruflich gelöscht. Alle Mitglieder verlieren mit sofortiger Wirkung den Zugriff auf  Projektdaten, Prüfergebnisse und Organisationsverwaltung.</span>
          </div>
          <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
            <bic-button (onClick)="deleteOrganisationBoolean = false" buttonType="white">Abbrechen</bic-button>
            <bic-button (onClick)="deleteOrganisation(selectedOrganisation!)" buttonType="red">Löschen</bic-button>
          </div>
        </bic-popup>
      }
<!--      @if (deleteAndLeaveOrganisationBoolean) {-->
<!--        <bic-popup (close)="deleteAndLeaveOrganisationBoolean = false" [hasBackdrop]="true"-->
<!--                   title="Möchten Sie Ihre Organisation löschen oder verlassen?" customClass="w-[560px] h-fit">-->
<!--          <div bicPopupContent class="flex flex-col">-->
<!--            <span class="font-normal">Beim löschen verlieren Sie und alle Mitglieder ihre Angehörigkeit zu dieser Organisation.<br><br>-->
<!--            Wählen Sie Verlassen, um selbst aus der Organisation auszutreten. Dabei bleibt die Organisation für alle anderen Mitglieder bestehen. Diese Option steht nur zur Verfügung wenn ein zusätzliches Mitglied über Administrationsrechte besitzt.</span>-->
<!--          </div>-->
<!--          <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">-->
<!--            <bic-button (onClick)="deleteAndLeaveOrganisationBoolean = false" buttonType="white">Abbrechen</bic-button>-->
<!--            <bic-button (onClick)="leaveOrganisation(selectedOrganisation)" buttonType="red">Verlassen</bic-button>-->
<!--            <bic-button (onClick)="deleteOrganisation(selectedOrganisation)" buttonType="red">Löschen</bic-button>-->
<!--          </div>-->
<!--        </bic-popup>-->
<!--      }-->
    </div>
</div>
}
